'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import styled from 'styled-components';
import { CANDY_APPLE_MEDIUM, CANDY_APPLE_LIGHT } from 'HubStyleTokens/colors';
const StyledUnderConstructionBox = styled.div.withConfig({
  displayName: "UnderConstruction__StyledUnderConstructionBox",
  componentId: "s5g9h8-0"
})(["background-color:", ";border:1px solid ", ";font-style:italic;padding:8px;margin:8px 0;"], CANDY_APPLE_LIGHT, CANDY_APPLE_MEDIUM);
export default class UnderConstruction extends Component {
  componentDidMount() {
    if (window.location.href.startsWith('https://local')) {
      console.log(`To do: ${this.props.component}`);
    }
  }

  render() {
    return /*#__PURE__*/_jsx(StyledUnderConstructionBox, {
      children: `${this.props.component} (under construction)`
    });
  }

}
UnderConstruction.propTypes = {
  component: PropTypes.string.isRequired
};